import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SAMPLE_REQUEST_TYPES } from '@/constants/constant';

import CommonImage from '@/components/CommonImage';
import AddTaskModal from '@/components/AddTaskModal';
import CostingAdd from '@/features/collection/components/CostingAdd';
import { useGetTaskDashboardFilterByIdQuery } from '@/features/my-dashborad/api/myDashboardApi';
import SampleRequestModal from '@/features/sampleDevelopment/components/SampleRequestModals/SampleRequestModal';
import RequestTo3DAndGraphicsModal from '@/features/sampleDevelopment/components/SampleRequestModals/RequestTo3DAndGraphicsModal';
import PhysicalSampleRequestModal from '@/features/sampleDevelopment/components/SampleRequestModals/PhysicalSampleRequestModal';
import { getUserTypeFromTaskValue } from '@/features/sampleDevelopment/utils';
import { checkUserType } from '@/utils/Util';
const TP_HANDOVER_TYPES = [
	SAMPLE_REQUEST_TYPES.TP_HANDOVER,
	SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_PROJECT_TEAM,
	SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_PATTERN_SECTION,
	SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_ACCOUNT_MANAGER,
	SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_DESIGNER
];

const SAMPLE_REQUEST_MODAL_TYPES = [
	SAMPLE_REQUEST_TYPES.SEND_TO_PD_IN_HOUSE,
	SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_NITEX_DESIGN,
	SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_BUYER_DESIGN,
	SAMPLE_REQUEST_TYPES.SAMPLE,
	SAMPLE_REQUEST_TYPES.SEND_REVISE_SAMPLE_REQUEST
];

const THREE_D_GRAPHICS_TYPES = [SAMPLE_REQUEST_TYPES.SEND_TO_3D, SAMPLE_REQUEST_TYPES.SEND_TO_GRAPHIC];

const BUYER_COSTING_TYPES = [
	'BUYER_COSTING_REQUESTED',
	'BUYER_COSTING_REQUESTED_FROM_AM_BDM',
	'BUYER_COSTING_REQUESTED_FROM_BUYER_PLATFORM'
];

const getModalType = (taskValueConstant) => {
	if (!taskValueConstant) return 'TASK_UPDATE';
	if (TP_HANDOVER_TYPES.includes(taskValueConstant)) return 'TP_HANDOVER';
	if (SAMPLE_REQUEST_MODAL_TYPES.includes(taskValueConstant)) return 'SAMPLE_REQUEST';
	if (THREE_D_GRAPHICS_TYPES.includes(taskValueConstant)) return '3D_GRAPHICS';
	if (BUYER_COSTING_TYPES.includes(taskValueConstant)) return 'BUYER_COSTING';
	if (taskValueConstant === 'INVENTORY_SAMPLE_REQUEST') return 'PHYSICAL_SAMPLE';
	return 'TASK_UPDATE';
};

const MyDashboardActionButtons = ({ productIdList = [], setSelectedProducts }) => {
	const [searchParams] = useSearchParams();
	const filterId = searchParams.get('filterId');
	const taskDashboardFilterId = filterId ? Number(filterId) : null;
	const { data: pendingTasks } = useGetTaskDashboardFilterByIdQuery(
		{ id: taskDashboardFilterId },
		{ skip: !taskDashboardFilterId || Number.isNaN(taskDashboardFilterId) }
	);
	const [isOpenModal, setIsOpenModal] = useState(false);
	const [selectedAction, setSelectedAction] = useState(null);

	const taskValueConstant = selectedAction?.taskValueType?.constant;
	const modalType = getModalType(taskValueConstant);

	const handleActionClick = (item) => {
		setSelectedAction(item);
		setIsOpenModal(true);
	};

	const handleCloseModal = () => {
		setIsOpenModal(false);
		setSelectedAction(null);
		setSelectedProducts([]);
	};

	const renderModal = () => {
		if (!isOpenModal || !selectedAction) return null;

		switch (modalType) {
			case 'TP_HANDOVER':
				return (
					<SampleRequestModal
						onClose={handleCloseModal}
						productIds={productIdList}
						requestType={taskValueConstant}
						title={
							selectedAction?.taskValueType?.name || selectedAction?.name || 'Techpack handover'
						}
						taskValueType={taskValueConstant}
						productActionId={selectedAction?.id}
						selectedHandoverUserType={getUserTypeFromTaskValue(taskValueConstant)}
						handoverModalFor={taskValueConstant}
						isHandoverModal={true}
					/>
				);
			case 'SAMPLE_REQUEST':
				return (
					<SampleRequestModal
						onClose={handleCloseModal}
						productIds={productIdList}
						requestType={taskValueConstant}
						title={selectedAction?.taskValueType?.name || selectedAction?.name}
						taskValueType={taskValueConstant}
					/>
				);
			case '3D_GRAPHICS':
				return (
					<RequestTo3DAndGraphicsModal
						title={selectedAction?.taskValueType?.name || selectedAction?.name}
						onClose={handleCloseModal}
						requestType={taskValueConstant}
						productIds={productIdList}
					/>
				);
			case 'BUYER_COSTING':
				return (
					<CostingAdd
						requestFrom="FAVOURITE"
						selectedDesignIds={productIdList}
						onClose={handleCloseModal}
					/>
				);
			case 'PHYSICAL_SAMPLE':
				return (
					<PhysicalSampleRequestModal onClose={handleCloseModal} selectedDesigns={productIdList} />
				);
			case 'TASK_UPDATE':
			default:
				return (
					<AddTaskModal
						onClose={handleCloseModal}
						productIdList={productIdList}
						selectedAction={selectedAction}
					/>
				);
		}
	};

	const allowedActions =
		pendingTasks?.taskCompletionAllowed?.filter((task) => {
			if (!Array.isArray(task?.userTypeResponseList) || task?.userTypeResponseList.length === 0) {
				return true;
			}

			return task.userTypeResponseList.some((userType) => checkUserType(userType.constant));
		}) || [];
	return (
		<>
			<div className="action-button d-flex gap-3">
				{allowedActions?.slice(0, 3)?.map((item) => (
					<button
						className="button size32 outline"
						key={item?.id}
						onClick={() => handleActionClick(item)}
					>
						{item?.name}
					</button>
				))}

				{allowedActions?.length > 3 && (
					<div className="option">
						<div className="dropdown">
							<button
								className="button size32 outline gap-2 dropdown-toggle d-flex align-items-center"
								type="button"
								id="menu"
								data-toggle="dropdown"
							>
								<p className="regular-14">{allowedActions?.length - 3} More</p>
								<CommonImage
									src="/icons/down-arrow-gray-dark-02.svg"
									width={20}
									height={20}
									alt="more_icon"
								/>
							</button>

							<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
								{allowedActions?.slice(3)?.map((item) => (
									<li
										role="presentation"
										className="px-4 pb-3 pt-3 active"
										key={item?.id}
										onClick={() => handleActionClick(item)}
									>
										<span className="font-weight-normal text-black">{item?.name}</span>
									</li>
								))}
							</ul>
						</div>
					</div>
				)}
			</div>
			{renderModal()}
		</>
	);
};

export default MyDashboardActionButtons;
